import React, {useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import {useLang} from '../../context/LanguageContext';
import {useAuth} from "../../context/AuthContext";
import BackButton from "../../components/BackButton";

const AccountPage = () => {
    const {userName, logout, currentUser, hasSubscription} = useAuth();
    const navigate = useNavigate();
    const { t } = useLang();

    const logoutUser = async () => {
        await logout();
        navigate('/')
    }

    useEffect(() => {
        if(!currentUser){
            navigate('/login')
        }
    }, [currentUser, navigate])

    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 relative">
          <BackButton onClick={() => navigate('/')} />

        <h1 className="mb-4 text-xl font-bold">
            {t('txt.accountWelcome')}, {userName}
        </h1>
          <div className="flex flex-col space-y-2 w-64 mb-4">
              <button
                  onClick={() => logoutUser()}
                  className="px-4 py-2 bg-[#e74c3c] text-white rounded"
              >
                  {t('btn.signOut')}
              </button>
              <button
                  onClick={() => navigate('/subscriptions')}
                  className="px-4 py-2 bg-[#34495e] text-white rounded"
              >
                  {t('btn.subs')}
              </button>

              {hasSubscription &&
                  <button
                      onClick={() => navigate('/mysubscription')}
                      className="px-4 py-2 bg-[#34495e] text-white rounded"
                  >
                      {t('btn.mySub')}
                  </button>
              }
              <button
                  onClick={() => navigate('/')}
                  className="px-4 py-2 bg-[#2ecc71] text-white rounded"
              >
                  {t('btn.homepage')}
              </button>
          </div>
      </div>
    );
};

export default AccountPage;
